module.exports = __webpack_public_path__ + "static/media/web p2.d72fb980.png";